module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-180x180-c77a7a30086b9092005b3c58b09ecf6a.png";